import { parsers, store, descriptors, flattenConfigGroups } from "@dinahmoe/dmafjs-core";

// TODO get rid of constnants that are only used in one place
import {
  STORE_VISUAL_TEMPLATES_PATH,
  VISUAL_TEMPLATE_PARSER_TYPE,
} from "../libs/constants/constants.js";

function _flattenTemplate(config) {
  if (!config) return;
  if (config.namespace) {
    const descriptor = descriptors.get(config.namespace);
    flattenConfigGroups(config, descriptor);
  }
  if (Array.isArray(config.children)) {
    for (const child of config.children) {
      _flattenTemplate(child);
    }
  }
}

class VisualParser {
  constructor() {
    parsers.addType(VISUAL_TEMPLATE_PARSER_TYPE, (config) => {
      for (const template of config.templates) {
        _flattenTemplate(template);
        store.set(`${STORE_VISUAL_TEMPLATES_PATH}.${template.templateUid}`, template);
      }
    });
  }
}

const visualParser = new VisualParser();
export { VisualParser, visualParser };
